import React from 'react';
import PropTypes from 'prop-types';

import HeaderMegaMenuBack from './HeaderMegaMenuBack';
import HeaderMegaMenuMenu from './HeaderMegaMenuMenu';
import HeaderMegaMenuSubmenu from './HeaderMegaMenuSubmenu';

const HeaderMegaMenu = ({ children, isOpen }) => <div className={`c-header-mega-menu ${isOpen ? 'is-open' : ''}`}>
    {children}
  </div>

HeaderMegaMenu.Back = HeaderMegaMenuBack;
HeaderMegaMenu.Menu = HeaderMegaMenuMenu;
HeaderMegaMenu.Submenu = HeaderMegaMenuSubmenu;

export default HeaderMegaMenu;

HeaderMegaMenu.propTypes = {
  children: PropTypes.node.isRequired,
};
